import React, { useEffect } from 'react';
import NotificationBar from './NotificationBar';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../Store/store';
import { hideNotification } from '../../Store/notificationSlice';

const GlobalNotificationBar: React.FC = () => {
    const dispatch = useDispatch();
    const notification = useSelector((state: RootState) => state.notification);

    useEffect(() => {
        if (notification.open) {
            const timer = setTimeout(() => {
                dispatch(hideNotification());
            }, 1500);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [notification.open, dispatch]);

    const notifications = notification.open && notification.message ? [{
        id: 'global',
        type: notification.type || 'info',
        title: notification.type ? notification.type.charAt(0).toUpperCase() + notification.type.slice(1) : 'Info',
        message: notification.message,
        dismissible: true,
    }] : [];

    return (
        <NotificationBar
            notifications={notifications}
            onDismiss={() => dispatch(hideNotification())}
            position="top"
            maxNotifications={1}
        />
    );
};

export default GlobalNotificationBar; 